import { IconSettingsColorPickerColorConfig } from './types';

export const ICON_SETTINGS_COLOR_PICKER_COLOR_CONFIG: IconSettingsColorPickerColorConfig = {
  '#5956ec': {
    color: { background: '#ecedfd', hover: '#dadbfc', active: '#afb4ff' },
  },
  '#4c98fb': {
    color: { background: '#eff6ff', hover: '#dbeafe', active: '#bfdbfe' },
  },
  '#24b264': {
    color: { background: '#f0fdf4', hover: '#ccf5de', active: '#9debc0' },
  },
  '#f59e0b': {
    color: { background: '#fffbeb', hover: '#fef3c7', active: '#fde68a' },
  },
  '#ef4444': {
    color: { background: '#fef2f2', hover: '#fee2e2', active: '#fecaca' },
  },
  '#999999': {
    color: { background: '#fafafa', hover: '#eaeaea', active: '#bfbfbf' },
  },
  '#4db2d4': {
    color: { background: '#e9faff', hover: '#d1eff7', active: '#a1deed' },
  },
  '#90be6d': {
    color: { background: '#ecfdf5', hover: '#d1fae5', active: '#a7f3d0' },
  },
  '#9c6644': {
    color: { background: '#fefcf9', hover: '#fef6f0', active: '#fdeedc' },
  },
  '#ed698f': {
    color: { background: '#ffebee', hover: '#ffd3da', active: '#ffb9c4' },
  },
};
